/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class Rave2bundlecomposite_legacy {
		get config(){
			return {
				'type':'DualAxis.legacy',
				'recommendWeight':0.9,
				'thumbnail': {
					'properties': {
						'itemAxis.gridLines.visible': true,
						'valueAxis.gridLines.visible': true
					}
				},
				'propertiesToSetBeforeData': [
					'widget.data.truncate'
				],
				'listenForPropChanges': [
					'widget.legend.size'
				],
				'slots':{
					'categories':{
						'sort':'asc',
						'icon':'xAxis',
						'tags': ['badge'],
						'mldTitleProperty': 'itemAxis.title'
					},
					'columnValue':{
						'sortable':true,
						'icon':'values',
						'tags': ['badge'],
						'mldTitleProperty': 'valueAxis.column.title'
					},
					'lineValue':{
						'sortable':true,
						'icon':'values',
						'tags': ['badge'],
						'mldTitleProperty': 'valueAxis.line.title'
					},
					'repeatHorizontal':{
						'icon':'multiplier_h',
						'sort':'asc'
					},
					'repeatVertical':{
						'icon':'multiplier_v',
						'sort':'asc'
					}
				},
				'propertyPrefixes': {
					'legend': 'widget.legend',
					'dataPoint': 'itemAxis.ticks.labels',
					'columnValue': 'valueAxis.column.title',
					'categories': 'itemAxis.title',
					'lineValue': 'valueAxis.line.title',
					'row': 'widget.repeatVertical.labels',
					'column': 'widget.repeatHorizontal.labels'
				},
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont'],
					'itemAxis.ticks.labels.color': ['valueAxis.ticks.labels.color','valueLabels.color','valueAxis.column.ticks.labels.color','valueAxis.line.ticks.labels.color'],
					'itemAxis.ticks.labels.font': ['valueAxis.ticks.labels.font','valueLabels.font','valueAxis.column.ticks.labels.font','valueAxis.line.ticks.labels.font'],
					'valueAxis.column.ticks.labels.color': ['valueAxis.line.ticks.labels.color'],
					'valueAxis.column.ticks.labels.font': ['valueAxis.line.ticks.labels.font']
				},
				'elementStyle': {
					'groupedAxes': [
						['itemAxis.ticks.labels','valueAxis.ticks.labels'],
						['itemAxis.title','valueAxis.title']
					]
				},
				'properties':{
					'color.title': {
						'multilingual': true
					},
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'itemAxis.title': {
						'multilingual': true
					},
					'valueAxis.column.title': {
						'multilingual': true
					},
					'valueAxis.line.title': {
						'multilingual': true
					},
					'format.compact':{
						'active':false
					},
					'markers.shape':{
						'active':false
					},
					'legendPosition':{
						'active':false
					},
					'legend.display':{
						'active':false
					},
					'optimizeSize':{
						'active':false
					},
					'effect.duration': {
						'active': false
					},
					'lineWithPoints.size': {
						'active': false
					},
					'column.borderWidth':{
						'active':false
					},
					'valueAxis.zeroOrigin':{
						'active':false,
						'defaultValue':true,
						'isReadOnly': true
					},
					'widget.legend.titleVisible': {
						'active':false,
						'defaultValue': false,
						'isReadOnly': true
					},
					'widget.legend.size': {
						'active': false
					},
					'itemAxis.title.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'valueAxis.title.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'itemAxis.ticks.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'valueAxis.ticks.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					},
					'valueAxis.line.ticks.labels.color': {
						'public': false
					},
					'valueAxis.column.title.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 4
					},
					'valueAxis.line.title.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 8
					},
					'valueAxis.column.ticks.labels.color': {
						'colorClass': true,
						'addButton': true,
						'displayPos': 13,
						'caption': 'conditionalFormattingTextColor'
					},
					'contrast.label.color': {
						'defaultValue': true
					},
					'itemAxis.ticks.labels.rotateAngle': {
						'percentage': false
					}
				},
				'queryHints':{
					'multiEdgeSort':true
				},
				config:{
					'include':[
						'widget.data.truncate',
						'widget.legend.display',
						'widget.legend.position',
						'bar.direction.vertical',
						'lines.smooth',
						'itemAxis.labels.layoutMode',
						'gridLines.visible',
						'markers.visible',
						'lineWithPoints.symbol',
						'backgroundColor',
						'widget.legend.backgroundColor',
						'itemAxis.title.visible',
						'valueAxis.title.visible',
						'valueAxis.zeroOrigin',
						'itemAxis.ticks.labels.font',
						'itemAxis.ticks.labels.color',
						'itemAxis.title.font',
						'itemAxis.title.color',
						'valueAxis.ticks.labels.font',
						'valueAxis.ticks.labels.color',
						'valueAxis.column.ticks.labels.color',
						'valueAxis.line.ticks.labels.color',
						'valueAxis.column.ticks.labels.font',
						'valueAxis.line.ticks.labels.font',
						'valueAxis.line.title.font',
						'valueAxis.line.title.color',
						'valueAxis.column.title.font',
						'valueAxis.column.title.color',
						'itemAxis.title',
						'valueAxis.column.title',
						'valueAxis.line.title',
						'gridlineColor',
						'itemAxis.ticks.color',
						'valueAxis.ticks.color',
						'valueLabels.visible',
						'labelColor',
						'contrast.label.color',
						'label.shadow',
						'effect.duration',
						'optimizeSize',
						'alignAxes',
						'column.borderColor',
						'column.borderWidth',
						'lineWithPoints.size',
						'swapLineColumn',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.font',
						'widget.legend.titleColor',
						'widget.legend.titleFont',
						'widget.legend.titleVisible',
						'widget.legend.swatch.symbol.default',
						'valueLabels.font',
						'valueLabels.color',
						'widget.repeatHorizontal.labels.color',
						'widget.repeatVertical.labels.color',
						'widget.repeatHorizontal.labels.font',
						'widget.repeatVertical.labels.font',
						'itemAxis.ticks.labels.visible',
						'itemAxis.ticks.visible',
						'valueAxis.ticks.labels.visible',
						'valueAxis.ticks.visible',
						'color.column',
						'color.line',
						'widget.legend.size',
						'widget.legend.titleVisible',
						'color.title',
						'itemAxis.ticks.labels.rotateAngle'
					],
					'exclude':[
						'sortX',
						'lineWithPoints.display'
					]
				},
				'usages':[
					'Comparison',
					'Trend'
				],
				'supportsMaintainAxisScale': true,
				'colorPalettes': {
					'single': {
						'color.column': {
							id: 'defaultPaletteIndex',
							labelId: 'propColumnColor',
							defaultColorIndex: 0
						},
						'color.line': {
							id: 'compositeLineColor',
							labelId: 'propLineAndSymbolColor',
							defaultColorIndex: 1
						}
					}
				}
			};
		}

	}
	return Rave2bundlecomposite_legacy;
});
